import React from 'react';

export default function StickyFooter({ children, className = '' }) {
  return <div className={`sticky-footer ${className}`}>{children}</div>;
}
